export default function Vendor($resource, ENV) {
  'ngInject';

  return $resource(
    `${ENV.apiUrl}/pingsta/vendors.json`,
    {},
    {
      'query':  {
        method: 'GET',
        isArray: false
      },
    }
  );
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/util/vendor.factory.js